import { ChatCompletionRequestMessage } from 'openai';

type RequestVoiceboxResponse =
  | {
      content: string;
      error?: never;
    }
  | {
      content?: never;
      error: string;
    };

export const requestStreamedVoicebox = ({
  openAiKey,
  messages,
  updateCallback,
}: {
  openAiKey: string;
  messages: ChatCompletionRequestMessage[];
  updateCallback?: (text: string) => void;
}) =>
  new Promise<RequestVoiceboxResponse>((resolve) => {
    // https://github.com/openai/openai-node/issues/18#issuecomment-1490970390
    const url = 'https://api.openai.com/v1/chat/completions';

    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', `Bearer ${openAiKey}`);

    const xhrDataToCode = (data: string): string => {
      const newUpdates = data
        .replace('data: [DONE]', '')
        .trim()
        .split('data: ')
        .filter(Boolean);
      const newUpdatesParsed = newUpdates.map((update) => {
        const parsed = JSON.parse(update);
        return parsed.choices?.[0]?.delta?.content || '';
      });
      const newUpdatesJoined = newUpdatesParsed.join('');
      return newUpdatesJoined;
    };
    xhr.onprogress = () => {
      updateCallback?.(xhrDataToCode(xhr.responseText));
    };

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          const fullCode = xhrDataToCode(xhr.responseText);
          resolve({ content: fullCode });
        } else {
          console.error(xhr.responseText);
          let error = `Request failed with status ${xhr.status}`;
          try {
            const obj = JSON.parse(xhr.responseText);
            if (obj?.error?.message) {
              error = obj.error.message;
              if (error.startsWith('Rate limit')) {
                error = 'Rate limit reached';
              }
            }
          } catch {
            //
          }
          resolve({ error });
        }
      }
    };

    xhr.send(
      JSON.stringify({
        // make sure we don't pass anything else
        messages: messages.map(({ content, role }) => ({ content, role })),
        model: 'gpt-3.5-turbo',
        // max_tokens: 100,
        // temperature: 0,
        stream: true,
      })
    );
  });

export const requestStreamedVoiceboxMocked = async ({
  mockedResponse,
  mockError,
  updateCallback,
}: {
  mockedResponse: string;
  mockError?: boolean;
  updateCallback?: (text: string) => void;
}): Promise<RequestVoiceboxResponse> => {
  let n = 0;
  while (n < mockedResponse.length) {
    n += 50;
    // eslint-disable-next-line no-await-in-loop
    await new Promise((resolve) => setTimeout(resolve, 100));

    if (mockError) {
      if (n > 1000) {
        break;
      }
    }

    const text = mockedResponse.slice(0, n);
    updateCallback?.(text);
  }

  if (mockError) {
    return { error: 'test error!' };
  }

  await new Promise((resolve) => setTimeout(resolve, 1000));

  return { content: mockedResponse };
};
